var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.649 3.644a.5.5 0 0 0-.004.707l3.162 3.202a.5.5 0 0 0 .711-.703l-2.81-2.846 2.845-2.81A.5.5 0 0 0 3.85.481L.65 3.644Zm12.354-.07-12-.074-.006 1 12 .074.006-1Z",
    fill: "#F22F22"
  })));
};
export default SvgArrow;